import { z } from 'zod'

/** Upload ceiling for a bridge-letter PDF, shared by the route and the modal. */
export const MAX_BRIDGE_LETTER_BYTES = 20 * 1024 * 1024

/**
 * Extend takes no body: the new end date is computed server-side as
 * `min(addDays(endDate, 30), cap)`.
 */
export const extendBridgeLetterSchema = z.object({})

export type ExtendBridgeLetterInput = z.infer<typeof extendBridgeLetterSchema>
